import { render, staticRenderFns } from "./PatientPhotosModal.vue?vue&type=template&id=823ca58a&scoped=true"
import script from "./PatientPhotosModal.vue?vue&type=script&lang=js"
export * from "./PatientPhotosModal.vue?vue&type=script&lang=js"
import style0 from "./PatientPhotosModal.vue?vue&type=style&index=0&id=823ca58a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823ca58a",
  null
  
)

export default component.exports